// extracted by mini-css-extract-plugin
module.exports = {"CardNumber":"CardMinimal_CardNumber__mhwfk","CardCvc":"CardMinimal_CardCvc__27S6s","CardExpiry":"CardMinimal_CardExpiry__1znsI","PayButton":"CardMinimal_PayButton__p1bg8"};